import { render } from "./CreditNotesExpenses.vue?vue&type=template&id=60edaa08"
import script from "./CreditNotesExpenses.vue?vue&type=script&lang=js"
export * from "./CreditNotesExpenses.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__